import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { I18n } from 'react-i18next';

class SelectInputWithIcons extends Component {
  onOpen = () => {
    if (this.props.onListOpen) this.props.onListOpen(this.props.value);
  };

  onClose = () => {
    if (this.props.onClose) this.props.onClose();
  };

  onChange = (selectedOption) => {
    if (this.props.handleChange) this.props.handleChange(selectedOption, this.props.title);
  };

  // Render option in dropdown menu
  optionRenderer = (option) => {
    return (
      <>
        {option.icon && (
          <span className="option-icon" style={{ width: '24px', height: '24px', marginRight: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {option.icon}
          </span>
        )}
        <span>{option.label}</span>
      </>
    );
  };

  // Render selected value
  valueRenderer = (option) => {
    return (
      <>
        {option.icon && (
          <span className="dropdown-icon" style={{ width: '24px', height: '24px', marginRight: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {option.icon}
          </span>
        )}
        <span>{option.label}</span>
      </>
    );
  };

  arrowRenderer = () => (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66431 7.33333C6.48809 7.33365 6.31354 7.29843 6.15071 7.2297C5.98789 7.16096 5.83999 7.06007 5.71553 6.93282L0 0.960129L0.962899 0L6.67238 5.96652L12.3704 0L13.3333 0.960129L7.62452 6.92665C7.49868 7.05567 7.34905 7.15803 7.18425 7.22782C7.01946 7.29762 6.84275 7.33348 6.66431 7.33333Z"
        fill="white"
      />
    </svg>
  );

  render() {
    const { options, value, disabled, title } = this.props;

    return (
      <I18n ns="translations">
        {(t) => (
          <div className="input">
            {title && (
              <p className="input-name">
                {t('api_filters', { returnObjects: true })[title] || title}
              </p>
            )}
            <div className="select-with-icon">
              <Select
                disabled={disabled}
                onClose={this.onClose}
                onOpen={this.onOpen}
                placeholder={t('generic_labels.please_select')}
                clearable={false}
                name={'form-field-' + title}
                onChange={this.onChange}
                value={value} // parent-controlled
                options={options}
                searchable={false}
                optionRenderer={this.optionRenderer}
                valueRenderer={this.valueRenderer}
                arrowRenderer={this.arrowRenderer}
              />
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default SelectInputWithIcons;
